import moment from "moment-timezone";
import { formValueSelector } from "redux-form";
import { store } from "../../global/app/store";

//9142B helper object;
const Util9142B = {
  /**
   * returns false if the begin date isn't within the specified date ranges for emergency/non-emergency
   */
  isEmergencyFilingAvailable(isEmergencyFlag, b5BeginDate) {
    let now = moment.tz(new Date(), "America/New_York").startOf("day");
    let emergency_available = true;
    if (b5BeginDate === null || b5BeginDate === "") {
      return false;
    }
    let raw_date = moment.tz(b5BeginDate, "America/New_York");
    let difference = Math.round(raw_date.diff(now, "days", true));
    if (isEmergencyFlag === "NO") {
      if (difference < 75 || difference > 90) {
        emergency_available = false;
      }
    } else {
      if (difference < 0) {
        emergency_available = false;
      }
    }
    if (isEmergencyFlag === "YES") {
      if (difference > 90) {
        emergency_available = false;
      }
    }
    return emergency_available;
  },

  /**
   * returns true if end date < begin date + 10 months
   */
  isNeedLengthAcceptable(nature_of_need, end_date, begin_date) {
    if (end_date === "" || end_date === undefined) return true;

    const values_expected_nature_of_need = [
      "Seasonal",
      "Peakload",
      "Intermittent",
    ];
    if (values_expected_nature_of_need.indexOf(nature_of_need) > -1) {
      let raw_end_date = moment.utc(end_date);
      let raw_begin_date = moment.utc(begin_date);
      return raw_end_date < raw_begin_date.add(10, "months");
    } else {
      return true;
    }
  },

  /*
  Gets number of workers from page B, number 4
  */
  getNumberOfWorkers() {
    const selector = formValueSelector("fieldArrays");
    let state = store.getState();

    let b4_number_workers =
      "pages[2].sections[0].fieldGroup.b4_number_workers.value";
    b4_number_workers = selector(state, b4_number_workers);

    return b4_number_workers;
  },

  /*
   * Return true if the number passed in is less than the value in b4 or if b4 is not specified
   */
  isWorkersLessThanWorkersSpecified(num_workers) {
    const selector = formValueSelector("fieldArrays");
    let state = store.getState();

    let b4_number_workers =
      "pages[2].sections[0].fieldGroup.b4_number_workers.value";
    b4_number_workers = selector(state, b4_number_workers);

    return parseInt(num_workers) <= parseInt(b4_number_workers);
  },

  /*
    If the user has linked a determined 9141 to a 9142B form,
    a warning message will be displayed for 9142B F.b.8  (Basic Wage Rate From)
    field based on the determined wage from 9141B field F.4

    Returns a boolean
    true: if the from_value is GOOD against the PW false if not

    Pass in last 3 arguments is the option for appendix A wage validation
    !! THIS IS STILL USED
  */
  isFromValueGreaterThanPrevailingWage(
    from_value,
    pw = null,
    pw_per = null,
    current_per = null
  ) {
    // REFACTOR: remove the below redux-form fields after h2b refactor
    const selector = formValueSelector(`fieldArrays`);
    let state = store.getState();
    let machineNameBase = `pages[7].sections[1].fieldGroup.`;
    let prevailingWageName = "_9141_f4_prevailing_wage";
    let prevailingWagePer = "_9141_f5_wage_per";
    let perName = "fb9_wage_per";
    let prevailing_wage = selector(
      state,
      `${machineNameBase}${prevailingWageName}.value`
    );
    let prevailing_wage_per = selector(
      state,
      `${machineNameBase}${prevailingWagePer}.value`
    );
    let current_wage_per = selector(
      state,
      `${machineNameBase}${perName}.value`
    );

    prevailing_wage_per = pw_per || prevailing_wage_per;
    // console.log(prevailing_wage_per)
    current_wage_per = current_per || current_wage_per;

    from_value = parseFloat(from_value);
    prevailing_wage = (pw && parseFloat(pw)) || parseFloat(prevailing_wage);

    let determined_rate_is_hourly =
      prevailing_wage_per &&
      (prevailing_wage_per === "Hourly" || prevailing_wage_per === "HR");
    // console.log(determined_rate_is_hourly)
    let error = false;

    // IF DETERMINED && HOURLY
    if (determined_rate_is_hourly) {
      switch (current_wage_per) {
        // If F.b.9 = hour, F.b.8 must be Greater than or equal to F.4
        case "HR":
        case "HOUR":
        case "Hour":
        case "Hourly":
          if (from_value < prevailing_wage) {
            error = true;
          }
          break;
        // If F.b.9 = week, then F.b.8 >= F.4 X 35
        case "WK":
        case "WEEK":
        case "Weekly":
          if (from_value < prevailing_wage * 35) {
            error = true;
          }
          break;
        // If F.b.9=Bi-weekly, then F.b.8 >= F.4 X 70
        case "BW":
        case "BI-WEEKLY":
        case "Bi-weekly":
          if (from_value < prevailing_wage * 70) {
            error = true;
          }
          break;
        // If F.b.9 = Month, then F.b.8 >= F.4 X 140
        case "MH":
        case "Month":
        case "MONTH":
        case "Monthly":
          if (from_value < prevailing_wage * 140) {
            error = true;
          }
          break;
        // If F.b.9 = Year, then F.b.8 >= F.4 X 1820
        case "YR":
        case "YEAR":
        case "Year":
          if (from_value < prevailing_wage * 1820) {
            error = true;
          }
          break;
        default:
          error = false;
          break;
      }
      return error;
    }
  },
  getProperCountyYear(isEmergency, determined_date, submitted_date) {
    let currentYear = new Date().getFullYear();
    const dateToCheck = new Date(`${currentYear}-07-01`);
    const afterDate = new Date(submitted_date) > dateToCheck;
    const afterDeterminedDate = new Date(determined_date) > dateToCheck;

    if ((isEmergency && afterDate) || (!isEmergency && afterDeterminedDate)) {
      currentYear = "2023";
    } else if (afterDate) {
      currentYear = "2023";
    }
    return currentYear;
  },
};

export default Util9142B;
